import React from 'react';
import { Button } from 'finform';
import { useAppSelector } from '#app/hooks/useAppStore';

const FilterButtons = ({ filterShow, setFilterShow, clearFilter }) => {
  const i18n = useAppSelector((state) => state.i18n);
  const showFilter = () => setFilterShow(true);
  const hideFilter = () => setFilterShow(false);

  const renderFilterClearButton = () => {
    return (
      filterShow && (
        <Button
          type="transparent"
          onClick={clearFilter}
          style={{ margin: '0px 20px 0px 35px' }}
          id="clear-filter"
        >
          {i18n.incomeOutcome.unsetFilter}
        </Button>
      )
    );
  };

  const renderFilterShowButton = () => {
    return (
      <Button
        type={filterShow ? 'main' : 'block'}
        onClick={() => (filterShow ? hideFilter() : showFilter())}
        id="filter"
        style={{ margin: '0px 20px 0px 35px' }}
      >
        <img
          style={{ marginRight: '8px' }}
          src={
            filterShow
              ? require('#app/assets/icons/filter_white.svg')
              : require('#app/assets/icons/filter_blue.svg')
          }
        />
        {i18n.incomeOutcome.filter}
      </Button>
    );
  };

  return (
    <>
      {renderFilterClearButton()}
      {renderFilterShowButton()}
    </>
  );
};

export default FilterButtons;
